// searching for elements by the specific structure is not ideal and can crash if bazaarvoice reviews
// HTML structure will change in the future, but we don't have any other selectors to rely on
export function getRelevantDataButtonByStructure(bvButtons) {
  if (!bvButtons?.values) return
  for (const button of bvButtons.values()) {
    if (button?.querySelector('span > svg') && button?.querySelector('span > span')) {
      return button
    }
  }
}

export const relevantDataCSSPartName = 'bv-relevant-data-label'
export function updateRelevantDataColor(bvButton) {
  const relevantDataSpan = bvButton.querySelector('span > svg, span > span')?.parentElement
  if (!relevantDataSpan) return

  if (relevantDataSpan.getAttribute('part') === relevantDataCSSPartName) return

  relevantDataSpan.setAttribute('part', relevantDataCSSPartName)
  relevantDataSpan.querySelector('span').setAttribute('style', 'color: currentColor;')
  relevantDataSpan.querySelector('svg').setAttribute('color', 'currentColor')
  relevantDataSpan.querySelectorAll('svg, g, path').forEach(g => {
    g.setAttribute('fill', 'currentColor')
  })
}

export function updateRelevantDataButtonStyles(shadowRoot) {
  const bvButtons = shadowRoot.querySelectorAll('button[class^="bv-rnr"]')
  if (bvButtons?.length === 0) return

  const bvButton = getRelevantDataButtonByStructure(bvButtons)
  if (!bvButton) return

  updateRelevantDataColor(bvButton)
}
